module.exports = __webpack_public_path__ + "static/media/20210411_151426_405_IMG_0469.64f9f49b.jpg";